import { render } from "./ModalStory.vue?vue&type=template&id=2b6444b0&scoped=true"
import script from "./ModalStory.vue?vue&type=script&lang=js"
export * from "./ModalStory.vue?vue&type=script&lang=js"

import "./ModalStory.vue?vue&type=style&index=0&id=2b6444b0&lang=scss&scoped=true"

import exportComponent from "/Users/mateomateus/Documents/Rabinovici/hp-blueprint-presentation/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b6444b0"]])

export default __exports__